import graphql from '@/api/graphql'
import Queries from '@/api/graphql/queries'
import Mutations from '@/api/graphql/mutations'
import { Extractor } from '@/api/utils'

export default {
  get: (payload = {}, options = {}) => {
    let { transform = Extractor } = options

    return graphql.request(Queries['Dashboard'], payload).then(transform)
  },
}
